import * as yup from 'yup';
import useTranslation from '../../../Hooks/useTranslation';

export default function usePatientManualRegistrationLatamFormValidationScheme(
	isChild: boolean,
	isPeru: boolean,
	hasHealthPlans: boolean,
) {
	const { t } = useTranslation();

	const validationSchema = yup.object({
		salutationBefore: yup.string().notRequired(),
		firstName: yup
			.string()
			.required(t('validation.patientManualRegistrationLatamForm.firstName')),
		middleName: yup.string().notRequired(),
		fatherLastName: yup
			.string()
			.required(
				t('validation.patientManualRegistrationLatamForm.fatherLastName'),
			),
		motherLastName: !isPeru
			? yup.string().notRequired()
			: yup
					.string()
					.required(
						t('validation.patientManualRegistrationLatamForm.motherLastName'),
					),
		lastName: yup.string().notRequired(),
		birthDate: yup
			.date()
			.typeError(
				t('validation.patientManualRegistrationLatamForm.birthDate') ?? '',
			)
			.required(t('validation.patientManualRegistrationLatamForm.birthDate')),
		gender: yup
			.mixed()
			.required(t('validation.patientManualRegistrationLatamForm.gender')),
		email: isChild
			? yup
					.string()
					.email(t('validation.patientManualRegistrationLatamForm.email'))
					.notRequired()
			: yup
					.string()
					.email(t('validation.patientManualRegistrationLatamForm.email'))
					.required(t('validation.patientManualRegistrationLatamForm.email')),
		phoneNumber: yup.string().notRequired(),
		healthPlanCode: !hasHealthPlans
			? yup.mixed().notRequired()
			: yup.object().shape({
					label: yup.string(),
					value: yup
						.string()
						.required(
							t('validation.patientManualRegistrationLatamForm.healthPlanCode'),
						),
			  }),
		healthPlanWorkplaceMember: yup.mixed().notRequired(),
		legalRepresentative: isChild
			? yup.object().shape({
					firstName: yup
						.string()
						.required(
							t(
								'validation.patientManualRegistrationCzechForm.legalRepresentative.firstName',
							),
						),
					lastName: yup
						.string()
						.required(
							t(
								'validation.patientManualRegistrationCzechForm.legalRepresentative.lastName',
							),
						),
					email: yup
						.string()
						.email(t('validation.patientManualRegistrationCzechForm.email'))
						.required(
							t(
								'validation.patientManualRegistrationCzechForm.legalRepresentative.email',
							),
						),
					phoneNumber: yup.string().notRequired(),
			  })
			: yup.mixed().notRequired(),
	});

	return { validationSchema };
}
